export const getVenues = (state) => state.venue?.venues;
export const getVenueInfo = (state) => state.venue?.venueInfo;
